export default __webpack_public_path__ + "static/media/simTransfer-2.702eed46.png";